export default {
  methods: {

    /**
     * Google Maps has changed the event code for clicks so we've needed to write custom code to attempt to extract the element from the click events on the google maps
     * 
     * Returns null if no element found
     */
    getElementFromClickEvent(evt) {
      // Find the mouse event property in the google mouse click event. It seems to change
      // In future, may be best to add a click listener on map itself and use .marker selector
      // OR have popover component support X/Y coordinates
      var mapElement = null
      for (let key in evt) {
        if (Object.prototype.hasOwnProperty.call(evt, key) && evt[key] instanceof MouseEvent) {
          mapElement = evt[key].target
          break
        }
        if (Object.prototype.hasOwnProperty.call(evt, key) && evt[key] instanceof PointerEvent) {
          mapElement = evt[key].target
          break
        }
      }

      return mapElement
    }
  }
}